import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TokenContext from "../context/TokenContext";
import Header from "./Header";
import Tabla from "./Tabla";
import { useState } from "react";
import { UserAuth } from "../context/AuthContext";
import { COLUMNSSUBPERIODOVACACIONAL } from "../columnas/ColumnasVacaciones";
import { aprobarRechazarSubperiodo, getSubperiodovacacional } from "../Redux/vacaciones";
import moment from "moment/moment";
import { clearSubperiodo } from "../Redux/vacaciones";
import ModalRegistroSubperiodo from "./modales/ModalRegistroSubperiodo";
import TablaSubperiodo from "./tablas/TablaSubperiodo";

const SubperiodoVacacional = () => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const { empleado } = UserAuth();
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const loadSubperiodoVacacionalSelector = useSelector(
    (store) => store.vacaciones.loadSubperiodoVacacional
  );
  const subperiodoVacacionalSelector = useSelector(
    (store) => store.vacaciones.subperiodoVacacional
  );
  const [subperiodoVacacional, setSubperiodoVacacional] = useState([]);
  const [loadSubperiodoVacacional, setLoadSubperiodoVacacional] =useState(false);

  const [openModal, setopenModal] = useState(false);
  const [subperidoModal, setSubperidoModal] = useState({});

  const handleCloseModal = () => setopenModal(false);

  useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(getSubperiodovacacional(token, empleado.usuarioPortalRh));
    }
  }, []);

  console.log("subperiodoVacacionalSelector", subperiodoVacacionalSelector)

  useEffect(() => {
    if (
      subperiodoVacacionalSelector?.length > 0 && loadSubperiodoVacacionalSelector) {
      const array = [];
      subperiodoVacacionalSelector.forEach((item) => {
        const obj = {
          id: item["new_subperiodovacacionalporaid"],
          subperiodo: item["new_name"],
          name: item["subper.new_name"],
          unidadOrganizativa:item["unidad.new_unidadsuperior@OData.Community.Display.V1.FormattedValue"],
          unidadOrganizativaID: item["_new_unidadorganizativa_value"],
          fechaDesdeHabilitada: moment(
            item["subper.new_fechadesdehabilitada"]
          ).format("DD-MM-YYYY"),
          fechaHastaHabilitada: moment(
            item["subper.new_fechahastahabilitada"]
          ).format("DD-MM-YYYY"),
          cumplirObjetivo: item["new_porcentajeacumplirobjetivo"],
          licenciasSubperiodo: item["new_porcentajelicenciasenelsubperiodo"],
          tamanioNomina: item["new_tamaonomina"],
          estado: item["statuscode"],
          cantidadLicencias: item["new_cantidadlicencias"],
          aprobador:item["_new_aprobador_value@OData.Community.Display.V1.FormattedValue"],
          aprobadorId: item["_new_aprobador_value"],
        };
        array.push(obj);
      });
      setSubperiodoVacacional(array);
      setLoadSubperiodoVacacional(loadSubperiodoVacacionalSelector);
    } else if ( subperiodoVacacionalSelector.length == 0 && loadSubperiodoVacacionalSelector) {
      setSubperiodoVacacional([]);
      setLoadSubperiodoVacacional(loadSubperiodoVacacionalSelector);
    }
  }, [subperiodoVacacionalSelector]);

  const handleVolverAtras = () => {
    navigate("/vacaciones");
    dispatch(clearSubperiodo());
  };

  const handleSubperiodo = (id, lineas) => {
    setopenModal(true);
    setSubperidoModal(lineas.find((item) => item.id == id));
  };

  const funcionConfirmacion = (id, estado) => {
    dispatch(aprobarRechazarSubperiodo(token, id, estado))
    .then(() => {
      handleCloseModal()
      setTimeout(() => {
        dispatch(getSubperiodovacacional(token, empleado.usuarioPortalRh))
      }, 4000);
    })
    .catch((error) => {
      console.error("Error:", error);
    })
  }



  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }}>
          <IconButton color={theme.palette.secondary[300]}>
            <ArrowBackIcon />
          </IconButton>
          <Typography color={theme.palette.secondary[300]}>
            Volver atrás
          </Typography>
        </Button>
        <Header title={"Subperiodo Vacacional por Unidad Organizativa"} />
        <Box sx={{ my: 4 }}>
          <Typography
            variant="h5"
            color={theme.palette.secondary[50]}
            fontWeight="bold"
            sx={{ mb: "5px" }}
          >
            Subperiodo Vacacional
          </Typography>
          {!loadSubperiodoVacacional ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                py: 2,
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          ) : subperiodoVacacional?.length > 0 ? (
            <TablaSubperiodo
              columnas={COLUMNSSUBPERIODOVACACIONAL}
              lineas={subperiodoVacacional}
              header={true}
              acciones={true}
              accionEliminar={true}
              accionConfirmar={true}
              funcionConfirmacion={funcionConfirmacion}
              handleOpen={handleSubperiodo}
            />
          ) : (
            <Alert severity="info">
              <AlertTitle>Info</AlertTitle>
              Aún no tienes registros de <strong>Subperiodo Vacacional</strong>.
            </Alert>
          )}
        </Box>
      </Box>
      {openModal && (
        <ModalRegistroSubperiodo
          open={openModal}
          handleClose={handleCloseModal}
          subperiodo={subperidoModal}
          onSubmit={funcionConfirmacion}
        />
      )}
    </motion.div>
  );
};
export default SubperiodoVacacional;
